module.exports = __webpack_public_path__ + "img/logo.822783fd.png";